import { graphql } from 'gql';

const bundledProductsQuery = graphql(`
  query BundledProducts($orderItemId: Int!) {
    bundled_options_query(orderItemId: $orderItemId) {
      type
      isMultiple
      isOptional
      bundledProductItems {
        id
        name
        description
        iconUrl
        thumbnailUrl
        isDefaultSelected
        price {
          initial {
            formatted
          }
          discount {
            formatted
          }
          total {
            formatted
          }
        }
      }
    }
  }
`);

export default bundledProductsQuery;
